import { Box, Flex, Text } from '@cmpsr/components';

type FactorsBalanceBarProps = {
  decreasing: number;
  increasing: number;
  stepSize: number;
};

export const FactorsBalanceBar = ({ decreasing, increasing, stepSize }: FactorsBalanceBarProps) => {
  const decreasingPercentage = Math.floor(decreasing * stepSize);
  const increasingPercentage = Math.floor(increasing * stepSize);

  return (
    <Flex alignItems="center" gap={2}>
      {decreasing > 0 && (
        <>
          <Box height="7px" bgColor="alert-success-default" width={`${decreasingPercentage}%`} borderRadius="radii-4" />
          <Text variant="text-body-meta-regular">{decreasing}</Text>
        </>
      )}
      {increasing > 0 && (
        <>
          <Box height="7px" bgColor="alert-error-default" width={`${increasingPercentage}%`} borderRadius="radii-4" />
          <Text variant="text-body-meta-regular">{increasing}</Text>
        </>
      )}
    </Flex>
  );
};
